import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { GroupItemService } from './group-item.service';
import {
  componentDestroyed,
  Tournament,
  TournamentGroup,
  TournamentRound,
  TournamentRoundTeam,
  UntilDestroy
} from '@mtgame/core';
import { filter, take, takeUntil } from 'rxjs/operators';
import { getTeamPageRoute } from '@config/routes';
import { ViewportService } from '@core/services/viewport.service';
import { DIVISION_QUERY_PARAM, ROUND_QUERY_PARAM, TOURNAMENT_QUERY_PARAM } from '@config/routing-map';

@UntilDestroy
@Component({
  selector: 'mtg-group-item',
  templateUrl: './group-item.component.html',
  styleUrls: ['../shared/group.scss', './group-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [GroupItemService],
})
export class GroupItemComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input()
  tournamentRound: TournamentRound;
  @Input()
  group: TournamentGroup;
  @Input()
  tournament: Tournament;
  @Input()
  title: string;
  teams: TournamentRoundTeam[];
  loading = true;

  constructor(
    private groupItemService: GroupItemService,
    private elementRef: ElementRef,
    private viewportService: ViewportService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.groupItemService.teams$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(teams => {
        this.teams = teams;
        this.cdr.markForCheck();
      });
  }

  ngAfterViewInit() {
    this.viewportService.track(this.elementRef.nativeElement)
      .pipe(
        filter(value => Boolean(value)),
        takeUntil(componentDestroyed(this)),
        take(1)
      ).subscribe(async () => {
        await this.groupItemService.initialize(this.tournamentRound.id, this.group.id);
        this.loading = false;
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy() {
    this.viewportService.deleteElement(this.elementRef.nativeElement);
    this.groupItemService.dispose();
  }

  getTeamRoute(teamId: number): string[] {
    return getTeamPageRoute(teamId);
  }

  get teamQueryParams() {
    return {[ROUND_QUERY_PARAM]: this.tournamentRound.id.toString(), [TOURNAMENT_QUERY_PARAM]: this.tournament.id.toString()};
  }
}
